import React from "react"
import ContactForm from "../../components/sutea/ContactForm"
import ContactOther from "../../components/sutea/ContactOther"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/sutea/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const contact = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.contact} siteTitle="すてあ" />
      <HeadingL title={PAGE.title.contact} target="sutea" />
      <ContactForm />
      <ContactOther />
    </Layout>
  )
}

export default contact
